export const isPropertyExposedLegend = {
  true: {
    label: 'Exposed',
    color: '#D0BFFF',
  },
  false: {
    label: 'Not exposed',
    color: '#69DB7C',
  },
  unknown: {
    label: 'Not known',
    color: '#868E96',
  },
}
